const EPHEMERAL_DATA_FIELDS = [
  'flowTrigger',
  'executionStatus',
  'previewResponses',
  'logs',
] as const;

export function stripEphemeralFields<T extends Record<string, unknown>>(
  data: T | null | undefined,
): T {
  if (!data || typeof data !== 'object') {
    return (data ?? {}) as T;
  }
  const result: Record<string, unknown> = {};
  for (const key of Object.keys(data)) {
    if (!EPHEMERAL_DATA_FIELDS.includes(key as (typeof EPHEMERAL_DATA_FIELDS)[number])) {
      result[key] = data[key];
    }
  }
  return result as T;
}

export function stripEphemeralFromNode<T extends { data?: unknown }>(node: T): T {
  if (!node || !node.data || typeof node.data !== 'object') {
    return node;
  }
  return {
    ...node,
    data: stripEphemeralFields(node.data as Record<string, unknown>),
  };
}
